import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml} from '@angular/platform-browser'
import { PageName, CONSTANTS } from '@app/constants';
import { DataService } from '@app/data';

@Component({
  selector: 'app-about',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.less']
})
export class AboutComponent implements OnInit {

  public currentTaxonomyPage$ = this.data.currentTaxonomyPage$;

  constructor(
    private data: DataService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    //console.log('DevelopComponent this.route ', this.route);
  }

  public getClass = (): string => this.data.getClass();

  public normalizeBody = (page: any | undefined): SafeHtml | undefined => {

    let absoluteBody;

    const body = page.description.value;

    if (body) {

      absoluteBody = body.split('/sites/default/files').join(CONSTANTS.baseUrl + '/sites/default/files');
      absoluteBody = absoluteBody.split('<a href').join('<a target="_blank" href');

    }

    const safeBody = this.sanitizer.bypassSecurityTrustHtml(absoluteBody);

    /*this.data.setScreen([{
      entityLabel: page.entityLabel,
      field_image_url: '/sites/default/files/2021-05/MNTM_home.jpg',
      fieldShortDescription: 'portál moderního vzdělávání',
      url: page.url
    }]);*/

    //console.log('ArticleComponent normalizeImages absoluteBody ', absoluteBody);

    return safeBody;
  }

}
